import React from "react";
import { Zoom } from "react-reveal";

const Footer = () => {
  const onServiceClick = (id) => {
    const element = document.getElementById(id);
    element.scrollIntoView();
  };

  return (
    <div id="footer">
      <div className="footer-top">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-xl-10">
              <div className="row">
                <div className="col-lg-2 col-md-6 footer-links">
                  <Zoom>
                    <h4>Useful Links</h4>
                  </Zoom>
                  <ul>
                    <Zoom right cascade>
                      <li>
                        {/* <i className="bx bx-chevron-right"></i> */}
                        <a
                          className="cursor-pointer"
                          onClick={() => onServiceClick("Home")}
                        >
                          Home
                        </a>
                      </li>
                    </Zoom>
                    <Zoom right cascade>
                      <li>
                        {/* <i className="bx bx-chevron-right"></i>{" "} */}
                        <a
                          className="cursor-pointer"
                          onClick={() => onServiceClick("Team")}
                        >
                          Team
                        </a>
                      </li>
                    </Zoom>
                    <Zoom right cascade>
                      <li>
                        {/* <i className="bx bx-chevron-right"></i>{" "} */}
                        <a
                          className="cursor-pointer"
                          onClick={() => onServiceClick("Client")}
                        >
                          Clients
                        </a>
                      </li>
                    </Zoom>
                  </ul>
                </div>

                <div className="col-lg-2 col-md-6 footer-links">
                  <Zoom>
                    <h4>Our Services</h4>
                  </Zoom>
                  <ul>
                    <Zoom right cascade>
                      <li>
                        {/* <i className="bx bx-chevron-right"></i>{" "} */}
                        <a
                          className="cursor-pointer"
                          onClick={() => onServiceClick("Gallery")}
                        >
                          Gallery
                        </a>
                      </li>
                    </Zoom>
                    <Zoom right cascade>
                      <li>
                        {/* <i className="bx bx-chevron-right"></i>{" "} */}
                        <a
                          className="cursor-pointer"
                          onClick={() => onServiceClick("Project")}
                        >
                          Projects
                        </a>
                      </li>
                    </Zoom>
                    <Zoom right cascade>
                      <li>
                        {/* <i className="bx bx-chevron-right"></i>{" "} */}
                        <a
                          className="cursor-pointer"
                          onClick={() => onServiceClick("About")}
                        >
                          About us
                        </a>
                      </li>
                    </Zoom>
                  </ul>
                </div>

                <div className="col-lg-4 col-md-6 footer-contact">
                  <Zoom>
                    <h4>Contact Us</h4>
                  </Zoom>
                  <Zoom right cascade>
                    <p>
                      101 , Action voice audio production Simran Plaza , corner
                      of 3rd & , Hasnabad Ln , Ram Krishna Nagar , Khar West ,
                      Mumbai , Maharashtra 400052
                    </p>
                  </Zoom>
                  <Zoom right cascade>
                    <p>
                      <strong>Phone:</strong> +91 98197 78588
                      <br />
                      <strong>Email:</strong> contactactionvoice@gmail.com
                      <br />
                    </p>
                  </Zoom>
                </div>

                <div className="col-lg-4 col-md-6 footer-info">
                  <Zoom>
                    <h3>About Action Voice</h3>
                  </Zoom>
                  <Zoom right cascade>
                    <p>
                      We specialize in various audio-production services such
                      as Audio Description, Dubbing, Voice-over  and language
                      dubs.
                    </p>
                    <p>
                      We have our own 5 state-of-the-art audio recording studios
                      where we have produced enormous hours of dubbing /
                      voice-over / post-production services.
                    </p>
                  </Zoom>
                  <div className="social-links mt-3">
                    <Zoom left cascade>
                      <a
                        href="https://www.facebook.com/Actionvoicestudios-108770701891431"
                        target={"_blank"}
                        className="facebook cursor-pointer"
                      >
                        <i className="bx bxl-facebook fFontSize"></i>
                      </a>
                    </Zoom>
                    <Zoom left cascade>
                      <a
                        href="https://instagram.com/action_voice_studio?igshid=YmMyMTA2M2Y="
                        target={"_blank"}
                        className="instagram cursor-pointer"
                      >
                        <i className="bx bxl-instagram fFontSize"></i>
                      </a>
                    </Zoom>
                    <Zoom left cascade>
                      <a
                        href="https://www.youtube.com/channel/UCA5MyopALxMfdtaHhkGxIBA"
                        target={"_blank"}
                        className="youtube cursor-pointer"
                      >
                        <i className="bx bxl-youtube fFontSize"></i>
                      </a>
                    </Zoom>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <Zoom left>
          <div className="copyright">
            &copy; Copyright{" "}
            <strong>
              <span>Action Voice</span>
            </strong>
            . All Rights Reserved
          </div>
        </Zoom>
        <div className="credits">
          <Zoom left cascade>
            Designed by
          </Zoom>
          <Zoom right cascade>
            <a
              href="https://www.linkedin.com/in/vishal-jariwala-203a83148/"
              target={"_blank"}
            >
              Vishal Jariwala
            </a>
          </Zoom>{" "}
          |{" "}
          <Zoom right cascade>
            <a
              href="https://in.linkedin.com/in/roshanijawale"
              target={"_blank"}
            >
              Roshani Jawale{" "}
            </a>
          </Zoom>
        </div>
      </div>
    </div>
  );
};

export default Footer;
